<template>
  <b-card class="phase-legend mt-3" border-variant="light" body-class="p-3">
    <p class="small font-weight-bold mb-2">About phases</p>
    <p v-if="note" class="small text-muted mb-2">{{ note }}</p>
    <ul class="phase-legend-list small mb-0 pl-0">
      <li v-for="phase in phases" :key="phase.value" class="mb-1">
        <strong>{{ phase.text }}</strong>
        <span class="text-muted"> &mdash; {{ phase.description }}</span>
      </li>
    </ul>
  </b-card>
</template>

<script>
import { PHASE_DESCRIPTIONS } from '@/util/notificationConfig';

export default {
  name: 'PhaseLegend',
  props: {
    note: { type: String, default: '' },
  },
  data() {
    return { phases: PHASE_DESCRIPTIONS };
  },
};
</script>

<style scoped>
.phase-legend-list {
  list-style: none;
}
</style>
